import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { useStyles } from '../style'
import { OutlinedButton } from '../../../elements'
import { TextField, MenuItem, Box, Button } from '@material-ui/core'
import { useFormik } from 'formik'
import * as yup from 'yup'
import _ from 'lodash'
import { reportService } from '../../../Services/ReportService/ReportService'
import { AppButton, DisplayMessage, Loader } from '../../../Components'
import * as messageTypes from '../../../utils/messageTypes'
import { COMMON } from '../../../utils/constants'
import { PROGRAM_SUMMARY } from '../constant'
import CustomDialog from '../../../Components/CustomDialog'
import { pushToDataLayer, USERBEHAVIOURTRACKING } from '../../../utils/gaEnvironment'

const validationSchema = yup.object({
  account: yup
    .string('Select account name')
    .required('Account name is required'),
})

function ProgramSummary(props) {
  const classes = useStyles()

  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [messageType, setMessageType] = useState('')
  const [loading, setLoading] = useState(false)
  const { currentUser } = props

  const formik = useFormik({
    initialValues: {
      account: (props.isSuperAdmin || props.isViewOnly) ? '' : currentUser && currentUser.account_id,
      email: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      pushToDataLayer({ event: USERBEHAVIOURTRACKING, accountID: currentUser.account_id, programID: values.program })
      getReport(values)
    },
  })

  const getReport = (values) => {
    setLoading(true)
    const { currentUser } = props
    const request = props.name === PROGRAM_SUMMARY ? reportService.getProgramSummaryReport(currentUser, values) : reportService.getUserSummaryReport(currentUser, values)
    request
      .then(reportData => {
        setLoading(false)
        setOpen(true)
        if (values.report_type === 'PDF') {
          let popUp = window.open(reportData, '_blank', '')
          if (popUp == null || typeof (popUp) == 'undefined') {
            setMessage('Please disable your pop-up blocker and download file again.')
            setMessageType(messageTypes.INFO)
          }
          else {
            setMessage('Report downloading')
            setMessageType(messageTypes.SUCCESS)
          }
        } else {
          downloadFile(reportData, values)
          setMessage('Report downloading')
          setMessageType(messageTypes.SUCCESS)
        }
      })
      .catch(error => {
        setLoading(false)
        setOpen(true)
        setMessage(_.get(error, 'data.error.displayMessage', 'Something went wrong'))
        setMessageType(messageTypes.ERROR)
      })
  }

  const downloadFile = (fileUrl, values) => {
    const a = document.createElement("a")
    a.href = fileUrl
    a.target = values.report_type === 'PDF' ? "_blank" : ''
    a.setAttribute("download", `ProgramSummaryReport_${new Date()}.${formik.values.report_type.toLowerCase()}`)
    a.click()
  }

  const handleChange = (e) => {
    const value = e.target.value
    formik.setFieldValue('account', value)
    formik.setFieldValue('email', props.currentUser.id)
  }

  useEffect(() => {
    formik.resetForm()
  }, [props.name])

  return (
    <>
      <Loader loading={loading} />
      <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
      <div className={classes.formHeading}>{props.name}</div>
      <div className={classes.formSubHeading}>Please {`${(props.isSuperAdmin || props.isViewOnly) ? 'enter the details' : 'click the buttons'}`} below to download the report.</div>
      <form onSubmit={formik.handleSubmit}>
        <Box my={5}>
          <Box display={(props.isSuperAdmin || props.isViewOnly) ? '' : 'none'}>
            <TextField
              label="Account Name"
              select
              name="account"
              fullWidth
              value={formik.values.account}
              disabled={!(props.isSuperAdmin || props.isViewOnly)}
              style={{ maxWidth: 500 }}
              onChange={handleChange}
              InputProps={{
                classes: { root: classes.input }
              }}
              SelectProps={{
                MenuProps: {
                  classes: { paper: classes.paper },
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                  },
                  getContentAnchorEl: null
                }
              }}
              error={formik.touched.account && Boolean(formik.errors.account)}
              helperText={formik.touched.account && formik.errors.account}
            >
              {(props.isSuperAdmin || props.isViewOnly) ? props.accounts.map(account => (
                <MenuItem value={_.get(account, 'id', '')}>{_.get(account, 'company_name', 'NA')}</MenuItem>
              )) :
                <MenuItem value={currentUser.account_id}>{currentUser.account_company_name}</MenuItem>
              }
            </TextField>
          </Box>
        </Box>
        <Box display="none">
          <TextField
            label="Account Name"
            select
            name="account"
            fullWidth
            value={formik.email}
            style={{ maxWidth: 500 }}
            onChange={formik.handleChange}
            InputProps={{
              classes: { root: classes.input }
            }}
            SelectProps={{
              MenuProps: {
                classes: { paper: classes.paper },
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left"
                },
                getContentAnchorEl: null
              }
            }}
          >
            {props.accounts.map(account => (
              <MenuItem value={_.get(account, 'id', '')}>{_.get(account, 'company_name', 'NA')}</MenuItem>
            ))}
          </TextField>
        </Box>
        <div>
          <span className={classes.mr2} ><OutlinedButton type="submit" label="Download CSV" onClick={() => { formik.setFieldValue('report_type', 'CSV') }} /></span>
          <span className={classes.mr2} ><OutlinedButton type="submit" label="Download PDF" onClick={() => { formik.setFieldValue('report_type', 'PDF') }} /></span>
        </div>
      </form>
    </>
  )
}

const mapStateToProps = ({ auth }) => {
  const { currentUser, isSuperAdmin, isViewOnly } = auth
  return { currentUser, isSuperAdmin, isViewOnly }
}

export default connect(mapStateToProps, {})(ProgramSummary)